import { set } from 'lodash';
import userService from '@/services/UserService';

// initial state
// shape: [{ id, quantity }]
const user = {

  state: {
    currentUser: {},
    userSignUpData: {},
  },
  mutations: {
    SET_USER_SIGNUP_DATA: (state, userSignUpData) => {
      set(state, 'userSignUpData', userSignUpData);
    },
    SET_CURRENT_USER: (state, currentUser) => {
      set(state, 'currentUser', currentUser);
    },
    SET_LEGAL_TERMS_AS_ACCEPTED: (state, payload) => {
      if (payload.status === 200) {
        set(state.currentUser, 'accepted_term_at', true);
      }
    },
  },
  actions: {
    async setUserSignUpData({ commit }, userSignUpData) {
      commit('SET_USER_SIGNUP_DATA', userSignUpData);
    },
    setCurrentUser({ commit }, currentUser) {
      commit('SET_CURRENT_USER', currentUser);
    },
    async getCurrentUser({ commit }) {
      const payload = await userService.getCurrentUser();
      commit('SET_CURRENT_USER', payload.data);
    },
    async acceptLegalTerms({ commit }) {
      const payload = await userService.acceptLegalTerms();
      commit('SET_LEGAL_TERMS_AS_ACCEPTED', payload);
    },
  },
};
export default user;
